import { render } from "./BasePrimaryButton.vue?vue&type=template&id=001c3d7c"
import script from "./BasePrimaryButton.vue?vue&type=script&lang=js"
export * from "./BasePrimaryButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__